import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { ArrowLeft } from 'lucide-react';
import { ActionButton } from '@/components/ActionButton';
import { ErrorAlert } from '@/components/ErrorAlert';
import { LoadingIcon } from '@/components/LoadingIcon';
import { EftposIntegrationCard } from '@/features/ipads/EftposIntegrationCard';
import { IPadDetailsCard } from '@/features/ipads/IPadDetailsCard';

export const Route = createFileRoute('/a/ipads/$deviceId')({
  staticData: {
    breadcrumbs: [{ label: 'iPads', url: '/a/ipads' }, { label: 'Details' }],
  },
  component: AdminIPadDetailsPage,
});

function AdminIPadDetailsPage() {
  const { deviceId } = Route.useParams();
  const { data, error, isError, isPending } = useQuery(api.iPads.adminGetDevice, { deviceId });

  if (isPending) return <LoadingIcon />;
  if (isError) return <ErrorAlert message={error.message} title="Error loading iPad details" />;
  if (!data) return <div>iPad not found.</div>;

  const { device, restaurantName, printerName, heartbeats } = data;

  return (
    <div>
      <div className="mb-4">
        <ActionButton asChild variant="outline" size="sm">
          <Link to="/a/ipads">
            <ArrowLeft className="h-4 w-4" />
            Back to list
          </Link>
        </ActionButton>
      </div>

      <IPadDetailsCard
        device={device}
        heartbeats={heartbeats}
        printerName={printerName}
        restaurantName={restaurantName}
      />

      {device.restaurantId && (
        <EftposIntegrationCard restaurantId={device.restaurantId} posTerminalUuid={device.uuid} />
      )}
    </div>
  );
}
